// config/providerRates.js
export default {
  "openai:gpt-4o-mini": {
    "input": 0.15,
    "output": 0.60,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openai:gpt-4o": {
    "input": 5.00,
    "output": 15.00,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openai:gpt-4-turbo": {
    "input": 10.00,
    "output": 30.00,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openai:gpt-3.5-turbo": {
    "input": 0.50,
    "output": 1.50,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openrouter:openai/gpt-4o-mini": {
    "input": 0.15,
    "output": 0.60,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openrouter:openai/gpt-4o": {
    "input": 5.00,
    "output": 15.00,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openrouter:google/gemini-flash-1.5": {
    "input": 0.35,
    "output": 0.70,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openrouter:anthropic/claude-3-haiku": {
    "input": 0.25,
    "output": 1.25,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "openrouter:mistralai/mistral-7b-instruct": {
    "input": 0.10,
    "output": 0.10,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "groq:llama3-8b-8192": {
    "input": 0.05,
    "output": 0.10,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "groq:llama3-70b-8192": {
    "input": 0.59,
    "output": 0.79,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "groq:mixtral-8x7b-32768": {
    "input": 0.27,
    "output": 0.27,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "groq:gemma-7b-it": {
    "input": 0.10,
    "output": 0.10,
    "unit": "USD_PER_MILLION_TOKENS"
  },
  "unknown": {
    "input": 0,
    "output": 0,
    "unit": "USD_PER_MILLION_TOKENS"
  }
}; 